import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { AngularFireDatabase } from '@angular/fire/database';
import {take} from 'rxjs/operators';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CartService {

  constructor(private firestore:AngularFirestore, private db:AngularFireDatabase) { }


  cart = {
    id:null,
    products:[]
  };

  private create(){
    var createdAt = { dateCreated:new Date().getTime()};
    return new Promise<any>((resolve, reject) =>{
      this.firestore
      .collection("shopping-carts")
      .add(createdAt)
        .then(function(docRef){
          if(docRef){
            resolve(docRef.id);
          }
        });
      });
  }

  getCart(cartId:string){
    return this.cart; 
  }

  private async getOrCreateCartId(product){
    let cartId = localStorage.getItem('cartId');
    if(!cartId){
      let result = await this.create();
      localStorage.setItem('cartId',result);
      return result;
      // this.create().then(result =>{});
    }
    else{
      return cartId;
    }
  }
  item:any;
  async addToCart(product, productId){
    let cartId = await this.getOrCreateCartId(product);
    // console.log('productId',productId, 'cartid',cartId);
    let item$ = this.db.object('/shopping-carts/' + cartId +'/items/' + productId);
    // console.log('item$',item$);
    item$.valueChanges()
    .pipe(take(1))
    .subscribe(res => console.log('res',res));
    
    /* .subscribe(res: any => {
      console.log('item',res); */
      /* if(item != null){
        item$.update({quantity: item.quantity + 1 });
      } 
      else{
        item$.set({product:product, quantity :1});
      } */  
    //});
    /* item$.pipe(take(1)).subscribe(item => {
      if(item === null ){
        item$.set({product:product, quantity :1});
      } 
      else{
        item$.update({quantity: item.quantity + 1 });
      }
    }); */
  }
}
